import React from "react";

import { INTEGRATION_LOGO_ICON_CLASS } from "../integrationLogoStyles";

export default function GoogleCalendarLogo({
	className = INTEGRATION_LOGO_ICON_CLASS,
}) {
	return (
		<img
			src={`${process.env.PUBLIC_URL}/icons/google-calendar.svg`}
			alt="Google Agenda"
			className={className}
			draggable={false}
		/>
	);
}
